// BITALY_LINK
export const BITALY_LINK = 'BITALY_LINK';
export const BITALY_LINK_RESPONSE = 'BITALY_LINK_RESPONSE';
export const BITALY_LINK_FAILURE = 'BITALY_LINK_FAILURE';

// REPORTS SEND
export const REPORT_SEND = 'REPORT_SEND';
export const REPORT_SEND_RESPONSE = 'REPORT_SEND_RESPONSE';
export const REPORT_SEND_FAILURE = 'REPORT_SEND_FAILURE';